import { TagValues } from 'src/easyclaim.app.libs/piexif';

export interface ExifCameraSettings {
	fStop: number | null;
	exposureTime: number | null;
	isoSpeed: number | null;
	focalLength: number | null;
	subjectDistance: number | null;
	flashMode: number | null;
}

export const buildExifIfd = (settings: ExifCameraSettings): Record<number, unknown> => {
	const exifIFD: Record<number, unknown> = {};
	const { fStop, exposureTime, isoSpeed, focalLength, subjectDistance, flashMode } = settings;

	if (fStop != null) {
		exifIFD[TagValues.ExifIFD.FNumber] = [Math.round(fStop * 10), 10];
	}

	if (exposureTime != null) {
		const exposureDenom = Math.round(1 / exposureTime);

		exifIFD[TagValues.ExifIFD.ExposureTime] = [1, exposureDenom];
	}

	if (isoSpeed != null) {
		exifIFD[TagValues.ExifIFD.ISOSpeedRatings] = isoSpeed;
	}

	if (focalLength != null) {
		exifIFD[TagValues.ExifIFD.FocalLength] = [Math.round(focalLength * 100), 100];
	}

	if (subjectDistance != null) {
		exifIFD[TagValues.ExifIFD.SubjectDistance] = [Math.round(subjectDistance * 100), 100];
	}

	if (flashMode != null) {
		exifIFD[TagValues.ExifIFD.Flash] = flashMode;
	}

	return exifIFD;
};
